import { Head } from 'vite-react-ssg/single-page';

export interface FAQItem {
    /** Question text -- also used as the JSON-LD question name. */
    question: string;
    /** One or more answer paragraphs. Combined for JSON-LD; each rendered as a <p>. */
    answer: readonly string[];
}

export interface FAQListProps {
    items: readonly FAQItem[];
}

/**
 * FAQ section that emits FAQPage JSON-LD from the same data it renders.
 * Each item's answer array renders as separate paragraphs; JSON-LD combines
 * them into one string for the acceptedAnswer text.
 */
export function FAQList({ items }: FAQListProps) {
    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: items.map((item) => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer.join(' '),
            },
        })),
    };

    return (
        <>
            <Head>
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            </Head>
            <section className="mktg-faq">
                <div className="mktg-container">
                    {items.map((item) => (
                        <div key={item.question}>
                            <h2 className="mktg-section-title">{item.question}</h2>
                            {item.answer.map((para, i) => (
                                <p key={i} className="mktg-faq__answer">{para}</p>
                            ))}
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
}
